import { render, staticRenderFns } from "./TFunctionalModeration.vue?vue&type=template&id=000d753f"
import script from "./TFunctionalModeration.vue?vue&type=script&lang=js"
export * from "./TFunctionalModeration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports